// TODO: how do we want to deal with AppError?
/**
 * @deprecated, we need to use some other error type
 */
export class AppError extends Error {
  constructor(
    public code: string,
    message?: string,
    details?: any
  ) {
    super(`${code}: ${message ?? ''} ${details ? JSON.stringify(details, null, 2) : ''}`);
  }

  public static isError(error: unknown, code: string | string[]) {
    return true;
  }
}
